



































































import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    UserMenuDropdown: () => import('@/containers/UserMenuDropdown.vue'),
    Breadcrumb: () => import('@/components/Breadcrumb.vue')
  }

})

export default class Header extends Vue {

}
